import { useEffect } from "react";
import { ProjetoPersonalizadoHibrido } from "src/components/projetos/personalizados_hibrido";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto personalizadoSSS híbrido";

const ProjetosPersonalizadosHibridoPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => appStore.setPageTitle("");
  }, []);
  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoPersonalizadoHibrido />
        </div>
      </div>
    </div>
  );
};

export { ProjetosPersonalizadosHibridoPage };
